import React, { useState } from "react";
import { useFormik } from "formik";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";
import * as Yup from "yup";
import { QuestionFooter } from "./QuestionFooter";
import Rating from "@mui/material/Rating";

const Circle = styled("div")(({ theme }) => ({
  width: 20,
  height: 20,
  borderRadius: "50%",
  backgroundColor: "#42a5f5",
}));

const EmptyCircle = styled("div")(({ theme }) => ({
  width: 20,
  height: 20,
  borderRadius: "50%",
  border: `1px solid #42a5f5`,
}));

const StyledRating = styled(Rating)(({ theme }) => ({
  display: "flex", 
  justifyContent: "center",
  alignItems: "center", 
  "& .MuiRating-icon": {
    margin: "0 4px",
  },
}));

export const Range = ({
  question,
  addAnswer,
  next,
  previous,
  options,
  initialValues,
}) => {
  const [selectedValue, setSelectedValue] = useState(
    initialValues?.value || 10
  );
  const { handleChange, handleSubmit: formikHandleSubmit, isValid, errors } = useFormik({
    initialValues: {
      answer: selectedValue,
    },
    onSubmit: (values) => {
      const answer = {
        question_id: question.id,
        answerText: selectedValue,
      };
      addAnswer(question.id, [answer]);
      next();
    },
    validateOnChange: true,
    validationSchema: Yup.object().shape({
      answer: Yup.number().required("Es muss eine Zahl eingetragen werden"),
    }),
  });


  const marks = [
    {
      value: question?.from ?? 0,
      label: `${question?.from ?? 0}`,
    },
  
    {
      value: question?.till ?? 100,
      label: `${question?.till ?? 100}`,
    },
  ];

  const from = question?.from ?? 1; 
  const till = question?.till ?? 10; 
  const interval = 1; 

  const steps = Math.ceil((till - from) / interval) + 1;
  const stepSize = (till - from) / (steps - 1);

  const handleRatingChange = (event, value) => {
    if (value !== null) {
      setSelectedValue(value);
    }
  };

  return (
    <div className="survey-choice">
        <div className="survey-number-answer">Deine Antwort:</div>
        <div className="survey-range">
          <StyledRating
            name="customized-color"
            value={selectedValue}
            precision={1} 
            max={steps}
            icon={<Circle />}
            emptyIcon={<EmptyCircle />}
            onChange={handleRatingChange}
            style={{ margin: "auto" }}
            getLabelText={(value: number) => `${Math.round(from + value * stepSize)}`}
          />
          <Typography fontSize={14} color="#238CB9" textAlign="center">
            {from} = sehr gering bis {till} = sehr hoch
          </Typography>
        </div>
      <QuestionFooter
        back={previous}
        onSave={formikHandleSubmit} 
        isValid={isValid}
        showErrorModal={
          typeof errors?.answer === "string" && errors.answer.length > 0
            ? errors.answer
            : ""
        }
      />
    </div>
  );
};
